import baseApi from "./RootBaseApi";
import {
  EmailTemplateListQueryParams,
  EmailTemplateListApiResponse,
  EmailTemplateSingleApiResponse,
  UpdateEmailTemplatePayload,
} from "@/types/email-template-management.types";

export const EmailTemplateService = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getEmailTemplates: builder.query<
      EmailTemplateListApiResponse,
      EmailTemplateListQueryParams
    >({
      query: ({ page, limit, search } = {}) => ({
        url: "email-templates",
        method: "GET",
        params: {
          page,
          limit,
          ...(search ? { search } : {}),
        },
      }),
      providesTags: ["EmailTemplates"],
      keepUnusedDataFor: 0,
    }),
    getEmailTemplateById: builder.query<
      EmailTemplateSingleApiResponse,
      { id: string; lang?: "en" | "fi" | "de" | "sv" }
    >({
      query: ({ id, lang = "en" }) => ({
        url: `email-templates/${id}`,
        method: "GET",
        headers: { "x-lang": lang },
      }),
      providesTags: (result, error, { id }) => [
        { type: "EmailTemplates" as const, id },
      ],
      keepUnusedDataFor: 0,
    }),
    updateEmailTemplate: builder.mutation<
      EmailTemplateSingleApiResponse,
      {
        id: string;
        data: UpdateEmailTemplatePayload;
        lang: "en" | "fi" | "de" | "sv";
      }
    >({
      query: ({ id, data, lang }) => ({
        url: `email-templates/${id}`,
        method: "PATCH",
        data,
        headers: { "x-lang": lang },
      }),
      invalidatesTags: (result, error, { id }) => [
        "EmailTemplates",
        { type: "EmailTemplates" as const, id },
      ],
    }),
  }),
});

export const {
  useGetEmailTemplatesQuery,
  useGetEmailTemplateByIdQuery,
  useUpdateEmailTemplateMutation,
} = EmailTemplateService;
